import { z } from 'zod'

export const errorAlertSchema = z.object({
  signature: z.literal('71aaa237-2370-405b-882e-63f6dee6ee8b'),
  message: z.string(),
})

export type ErrorAlertRequest = z.infer<typeof errorAlertSchema>
